// react
import { forwardRef } from 'react';

// tanstack
import { createLink } from '@tanstack/react-router';

// material ui icons
import EditRoundedIcon from '@mui/icons-material/EditRounded';

// material ui
import Button, { type ButtonProps } from '@mui/material/Button';

type EditButtonProps = Omit<ButtonProps<'a'>, 'variant'>;

const EditButton = forwardRef<HTMLAnchorElement, EditButtonProps>(
  function EditButton(props, ref) {
    const { startIcon = <EditRoundedIcon />, ...rest } = props;

    return (
      <Button
        ref={ref}
        component="a"
        variant="contained"
        startIcon={startIcon}
        {...rest}
      />
    );
  },
);

export const EditButtonLink = createLink(EditButton);
